import styled from 'styled-components';
export const Container = styled.div`
   position: relative;
   display: flex;
   flex-direction: column;
   padding: 1rem;
   align-items: center;
   .skeleton--box{
      position:relative;
      display: flex;
      width: 140px;
      height: 140px;
      border-radius: 10px;
      justify-content: center;
      align-items: center;
      background-color: #e9ecef;
      .icon--{
         position: absolute;
         font-size: 4rem;
         z-index: 9;
         opacity: 0.2;
      }
   }
   .skeleton::before{
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 10px;
      content: "";
      height: 100%;
      width: 100%;
      background-color: #e9ecef;
      background-image: linear-gradient(to right, #e9ecef 0%, rgba(0,0,0,0.05) 20%, #e9ecef 40%, #e9ecef 100%);
      background-repeat: no-repeat;
      background-size: 450px 400px;
      animation: shimmer 2s linear infinite;
   }
   @keyframes shimmer {
      0%{
         background-position: -450px 0;
      }
      100%{
         background-position: 450px 0;
      }
   }
`;
export const Content = styled.div`
   position: relative;
   img{
      width: 140px;
      height: 140px;
   }
`;
export const Time = styled.div`
   position: relative;
   width: 100%;
   height: 15px;
   > span {
      top: 0;
      position: absolute;
      right: 0px;
      color: #999;
      font-size: 11px;
      padding: 0.2rem;
      background-color: #ffffff;
      box-shadow: 0 1px 1px #ccc;
      border-radius: 6px;
      pointer-events: none;
   }
`;